const Hr = () =>
    <hr style={{ borderColor: 'var(--input-border-c)', borderWidth: '0 0 5px 0', margin: 0 }} />

export default Hr